<h1><small>Creating new quote...</small></h1>
